<template>
    <div class="item">
      <div class="info">
        <div v-if="is_live" class="is_live">Canlı</div>
        <div class="count">{{ count }}</div>
        <div class="name">
          <span><slot name="home"></slot></span>
          <br>
          <span><slot name="away"></slot> </span>
          <br>
          <div>
            <b><slot name="time"></slot> </b> 
            &nbsp;
            
            <small><slot name="statistic"></slot></small>
          </div>
        </div>
      </div>
      <div class="bets">
          <div class="market">
            <slot name="market"></slot>
            
          </div>
          <div class="outcome">
              <slot name="outcome"></slot>
          </div>
          <div class="bet">
            <b><slot name="odd"></slot></b>
            <span class="status-label" :class="'status_' + status_id">{{ status }}</span>
          </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['event_id', 'status', 'count', 'status_id', 'is_live']
  }
</script>